export const initState = {
  pending: [],
  withDrawn: [],
  Rejected: [],
};
